interface IBannerProps {
    text: string;
}

export default function Banner(props: IBannerProps) {
    const { text } = props;

    return (
        <div className="text-balance w-fit md:text-nowrap top-label flex gap-3 justify-center rounded-2xl items-center px-4 py-2 bg-primary-50 border border-primary-200 text-primary-700">
            <h3>{text}</h3>
        </div>
    )
}